import React, { ReactNode } from 'react';
import Form from 'react-bootstrap/Form';
// @ts-ignore: no def
import DatePicker from 'react-datepicker';
import styles from './PromotionForm.module.scss';

const PACIFIC_TIME_ZONE = 'America/Los_Angeles';
const DEFAULT_PACIFIC_HOUR = 8;

const createFilterTimeBefore = (earliestDate: Date) => (selected: Date) => {
  const selectedDate = new Date(selected);
  return earliestDate.getTime() < selectedDate.getTime();
};

function getTimeZoneOffsetMs(date: Date, timeZone: string) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).formatToParts(date);

  const valueFor = (type: string) => {
    const part = parts.find((item) => item.type === type);
    return Number(part?.value);
  };

  const asUtc = Date.UTC(
    valueFor('year'),
    valueFor('month') - 1,
    valueFor('day'),
    valueFor('hour') % 24,
    valueFor('minute'),
    valueFor('second'),
  );
  return asUtc - date.getTime();
}

function eightAmPacificAsLocalDate(onDate = new Date()) {
  const year = onDate.getFullYear();
  const month = onDate.getMonth();
  const day = onDate.getDate();
  const utcGuess = Date.UTC(year, month, day, DEFAULT_PACIFIC_HOUR, 0, 0);
  const firstPass = new Date(utcGuess - getTimeZoneOffsetMs(new Date(utcGuess), PACIFIC_TIME_ZONE));
  const eightAmPacific = new Date(
    utcGuess - getTimeZoneOffsetMs(firstPass, PACIFIC_TIME_ZONE),
  );
  const next = new Date(onDate);
  next.setHours(eightAmPacific.getHours(), eightAmPacific.getMinutes(), 0, 0);
  return next;
}

interface PromotionDateTimeFieldProps {
  label: ReactNode;
  value: string;
  onChange: (date: Date) => void;
  minDateTime: Date;
  error?: string;
}

export function PromotionDateTimeField(props: PromotionDateTimeFieldProps) {
  const {
    value,
    onChange,
    minDateTime,
    label,
    error,
  } = props;

  return (
    <Form.Group className={styles.dateTimeField}>
      <Form.Label className={styles.dateTimeLabel}>{label}</Form.Label>
      <div className={styles.dateTimeInput}>
        <DatePicker
          showTimeSelect
          dateFormat="Pp"
          selected={value ? new Date(value) : null}
          openToDate={value ? new Date(value) : eightAmPacificAsLocalDate()}
          onChange={onChange}
          filterTime={createFilterTimeBefore(minDateTime)}
          minDate={minDateTime}
          className="form-control"
        />
        {Boolean(error) && (
          <Form.Control.Feedback
            type="invalid"
            className="d-block"
          >
            {error}
          </Form.Control.Feedback>
        )}
      </div>
    </Form.Group>
  );
}
